import { Controller, useFormContext } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import {
  DocumentTag_CreateDocumentTagInput,
  DocumentTagCategory,
  DocumentTagLinkedField,
} from 'queries';

import FormSelectField from 'common/form-select-field';
import FormTextField from 'common/form-text-field';

const useStyles = makeStyles(() => ({
  container: {
    textAlign: 'left',
  },
  button: {
    marginTop: '20px',
  },
  pillContainer: {
    display: 'flex',
  },
  pill: {
    padding: '4px 8px',
    borderRadius: '10px',
    margin: '10px 0',
  },
  label: {
    textTransform: 'capitalize',
  },
  infoText: {
    marginTop: '20px',
    fontSize: '14px',
    color: '#666',
  },
}));

export const linkedFieldOptions: Record<DocumentTagLinkedField, string> = {
  [DocumentTagLinkedField.DocumentIdLettersTestamentary]: 'Letters Testamentary',
  [DocumentTagLinkedField.DocumentIdDeathCertificate]: 'Death Certificate',
  [DocumentTagLinkedField.DocumentIdFrontOfPhotoId]: 'Front of Photo ID',
  [DocumentTagLinkedField.DocumentIdBackOfPhotoId]: 'Back of Photo ID',
  [DocumentTagLinkedField.DocumentIdLegalDocumentation]: 'Legal Documentation',
};

const DocumentTagForm = () => {
  const classes = useStyles();
  const {
    formState: { errors },
    control,
    watch,
  } = useFormContext<DocumentTag_CreateDocumentTagInput>();

  const row = watch();

  const linkedFieldSelectOptions = Object.entries(linkedFieldOptions).map(([value, label]) => ({
    value,
    label,
  }));

  const categorySelectOptions = [
    ...Object.values(DocumentTagCategory).map((category) => ({
      value: category,
      label: <div className={classes.label}>{category.replace('_', ' ')}</div>,
    })),
  ];

  return (
    <div className={classes.container}>
      <div className={classes.container}>
        <Controller
          name="name"
          control={control}
          render={({ field: { ref, onChange, ...field } }) => (
            <FormTextField
              {...field}
              inputRef={ref}
              label="Name"
              autoFocus
              onChange={(evt) => onChange(evt.target.value)}
              inputProps={{ maxLength: 80 }}
              errorMessage={errors.name?.message}
            />
          )}
        />
      </div>
      <div>
        <Controller
          name="pillTextColor"
          control={control}
          render={({ field: { ref, ...field } }) => (
            <FormTextField
              {...field}
              inputRef={ref}
              autoFocus
              label="Pill Text Color"
              inputProps={{ maxLength: 80 }}
              errorMessage={errors.pillTextColor?.message}
            />
          )}
        />
      </div>

      <div>
        <Controller
          name="pillBackgroundColor"
          control={control}
          render={({ field: { ref, ...field } }) => (
            <FormTextField
              {...field}
              inputRef={ref}
              autoFocus
              label="Pill Background Color"
              inputProps={{ maxLength: 80 }}
              errorMessage={errors.pillBackgroundColor?.message}
            />
          )}
        />
      </div>
      <div>
        <div className={classes.pillContainer}>
          <div
            style={{
              backgroundColor: row.pillBackgroundColor,
              color: row.pillTextColor,
            }}
            className={classes.pill}
          >
            {row.name}
          </div>
        </div>
      </div>
      <div>
        <Controller
          name="category"
          control={control}
          render={({ field: { ref: _, ...field } }) => (
            <FormSelectField
              {...field}
              errorMessage={errors.category?.message}
              includeNullOption
              options={categorySelectOptions}
              label="Category"
            />
          )}
        />
      </div>
      <div className={classes.infoText}>
        Also update the following estate field. Leave blank if this doesn't update the estate
      </div>
      <div>
        <Controller
          name="linkedField"
          control={control}
          render={({ field: { ref: _, ...field } }) => (
            <FormSelectField
              {...field}
              errorMessage={errors.linkedField?.message}
              includeNullOption
              options={linkedFieldSelectOptions}
              label="Field in Estate"
            />
          )}
        />
      </div>
    </div>
  );
};

export default DocumentTagForm;
